'use client'

import * as React from "react";
import { Avatar } from "@nextui-org/react";
import SignOutButton from "./auth/SignOutButton";
import { PersonIcon } from "./icons";

export const  UserAvatar = ( props: { src: string | null | undefined}) => {
	const { src } = props;
  return (
	<SignOutButton confirmSignOut={true} isIconOnly={true} >
		{src ? <Avatar size='sm' src={src} /> : <PersonIcon />}
		{/* <Avatar size='sm' src={src ?  src : ""} /> */}
	</SignOutButton>
  )
}